import { EnvironmentSettings, EnvironmentType } from '../types';

export const baseDevelopEnvironment: EnvironmentSettings = {
  aaptivUserPortalUrl: '',
  aaptivServiceUrl: 'https://skyfit-develop.aapdev.com',
  productionMode: true,
  repTime: 3,
  sentryDsn:
    'https://6bcb7dc730bb44858a6b20f99d895a03@o367782.ingest.us.sentry.io/5176798',
  sentryServiceTag: 'admin-ui',
  serverEnvironment: EnvironmentType.development,
  defaultTenantId: '64f791c6d14d7ff99013f4af',
};
